import { mapNaNAsZero } from './mapNaNAsZero';

export const makeANumber = (input: string | undefined): number => (input === undefined ? 0 : mapNaNAsZero(Number(input.toString().replace(',', '.'))));
